import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { AppModule } from './app.module';

if (process.env.ENV !== 'localdevelopment') {
	enableProdMode();
}
platformBrowserDynamic().bootstrapModule(AppModule,);